import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ExternalLink, Instagram, Star, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { getPartnerSlug } from '../../data/partners';

const FeaturedPartnerCard = ({ partner }) => {
  const to = `/partners/${getPartnerSlug(partner)}`;
  return (
    <Card
      className="group overflow-hidden border-none shadow-md hover:shadow-xl transition-all duration-300 bg-white"
      data-testid={`featured-partner-${partner.id}`}
    >
      <Link to={to} className="block relative h-32 overflow-hidden">
        <img
          src={partner.image}
          alt={partner.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute top-3 left-3 bg-[#DE92A9] text-white px-2.5 py-1 text-[10px] tracking-wider rounded">
          <Star size={10} className="inline mr-1" fill="white" />
          FEATURED
        </div>
        <div className="absolute top-3 right-3 bg-white/90 text-[#2C2C2C] px-2.5 py-1 text-[10px] tracking-wider rounded">
          {partner.category}
        </div>
      </Link>
      <CardContent className="p-6">
        <Link to={to}>
          <h3
            className="text-2xl md:text-3xl text-[#2C2C2C] mb-2 group-hover:text-[#DE92A9] transition-colors leading-tight"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            {partner.name}
          </h3>
        </Link>
        <div className="flex items-center gap-1 text-xs text-[#8B7D6B] mb-3">
          <MapPin size={14} />
          <span>{partner.location}</span>
        </div>
        <p className="text-[#6B4E37] text-sm leading-relaxed mb-4 line-clamp-2">
          {partner.description}
        </p>
        <div className="flex items-center gap-3">
          <Link
            to={to}
            className="inline-flex items-center gap-1 text-xs tracking-[0.15em] font-semibold text-[#DE92A9] hover:text-[#C9758F] transition-colors"
            data-testid={`featured-partner-profile-link-${partner.id}`}
          >
            VIEW PROFILE <ArrowRight size={13} />
          </Link>
          <span className="flex-1" />
          {partner.website && partner.website !== '#' && (
            <a href={partner.website} target="_blank" rel="noopener noreferrer" aria-label={`${partner.name} website`} className="text-[#A0978A] hover:text-[#DE92A9] transition-colors">
              <ExternalLink size={15} />
            </a>
          )}
          {partner.instagram && partner.instagram !== '#' && (
            <a href={partner.instagram} target="_blank" rel="noopener noreferrer" aria-label={`${partner.name} Instagram`} className="text-[#A0978A] hover:text-[#DE92A9] transition-colors">
              <Instagram size={15} />
            </a>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default FeaturedPartnerCard;
